import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=3c4bd608&scoped=true&"
import script from "./signature.vue?vue&type=script&lang=ts&"
export * from "./signature.vue?vue&type=script&lang=ts&"
import style0 from "./signature.vue?vue&type=style&index=0&id=3c4bd608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bd608",
  null
  
)

export default component.exports